import _ from 'lodash';
export const customDisplayConfig = (pipeConfig) => {
  return {
    volumeInterval: _.get(pipeConfig, 'chartConfig.type') === 'volumeCandle'
  };
};
